import { useMemo } from "react";

import { uniq } from "ramda";

type UseQuantityOptionsProps = {
  product: {
    selectOptions: number[];
    maxQuantity: number;
  };
  currentQuantity?: number;
};

/**
 * 購入時のセレクターの選択肢を返す
 * @param param0
 * @returns
 * @description
 * - maxQuantity、currentQuantityでより大きい値以下の選択肢を返す
 * - currentQuantityがあればそれも追加される
 * - 重複は除外される
 * - 昇順にソートされる
 */
export const useQuantityOptions = ({ product, currentQuantity }: UseQuantityOptionsProps) => {
  const quantityOptions = useMemo(() => {
    return makeQuantityOptions({ product, currentQuantity });
  }, [currentQuantity, product]);
  return quantityOptions;
};

export const makeQuantityOptions = ({ product, currentQuantity }: UseQuantityOptionsProps) => {
  const { maxQuantity, selectOptions } = product;
  const limitedQuantity = Math.max(maxQuantity, currentQuantity ?? 0);
  let options = selectOptions.filter((option) => option <= limitedQuantity);
  if (currentQuantity !== undefined && currentQuantity !== null) {
    options = [...options, currentQuantity];
  }
  options = uniq(options).sort((a, b) => a - b);
  return options.map((option) => ({
    label: option.toLocaleString(),
    value: option,
  }));
};

/**
 * ゼロ以外のオプションがあるかどうかを判定する
 * @param options - オプションの配列
 * @returns ゼロ以外のオプションがある場合はtrue、それ以外はfalse
 */
export const isQuantityOptionsEnabled = (options: { value: number }[]) => {
  return options.some((option) => option.value !== 0);
};
